import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import useStyles from "./dashAuction.style";
import DashboardMenu from "../../commonComponents/DashboardMenu";
import AuctionTable from "./AuctionTable";
import AuctionTableBuyer from "./AuctionTableBuyer";
import AuctionDetailLogs from "./AuctionDetailLogs";
import AuctionView from "./AuctionView";
import AuctionViewBuyer from "./AuctionViewBuyer";
import BidlogFirst from "./BidlogFirst";
import BidlogSecond from "./BidogSecond";
import BidlogSecondBuyer from "./BidogSecondBuyer";
import DashBuyerDetail from "./BidlogFirst/DashBuyerDetail";
import DashEventDetail from "./BidlogFirst/DashEventDetail";
import BuyerBidLog from "./BidlogFirst/BuyerBidLog";
import EditEvent from "./EditDashEvent/EditEvent";
import EditTabEvent from "./EditDashEvent/EditTabEvent";
import AuctionViewFirst from "./BidlogFirst/AuctionViewFirst";
import AuctionSummary from "./BidlogFirst/AuctionSummary";
import { getUserData } from "../../../common";

function DashboardAuction(props) {
  const classes = useStyles();
  const [searchParams, setSearchParams] = useSearchParams();
  const userData = getUserData() ?? {};

  const changeView = searchParams.get("view");
  const eventId = searchParams.get("eventId") || "";
  const buyerId = searchParams.get("buyerId") || "";
  const buyerEventId = searchParams.get("buyerEventId") || "";
  const buyerEventItemId = searchParams.get("buyerEventItemId") || "";
  const eventItemId = searchParams.get("eventItemId") || "";

  const updateView = (newParams) => {
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    setSearchParams({ ...params, ...newParams });
  };

  const renderComponent = () => {
    switch (changeView) {
      case "AuctionView":
        return userData.role === "BUYER" ? (
          <AuctionViewBuyer
            changeView={(view) => updateView({ view })}
            Bidlog={() => {
              updateView({ view: "AuctionBid" });
            }}
            BidlogSecond={(eventItemId) => {
              updateView({ view: "BidlogSecond", eventItemId });
            }}
            AuctionTable={() => {
              updateView({ view: "AuctionTable" });
            }}
            eventId={eventId}
          />
        ) : (
          <AuctionView
            changeView={(view) => updateView({ view })}
            Bidlog={() => {
              updateView({ view: "AuctionBid" });
            }}
            BidlogSecond={(eventItemId) => {
              updateView({ view: "BidlogSecond", eventItemId });
            }}
            AuctionTable={() => {
              updateView({ view: "AuctionTable" });
            }}
            eventId={eventId}
          />
        );
      case "AuctionDetailLogs":
        return (
          <AuctionDetailLogs
            AuctionView={() => updateView({ view: "AuctionView" })}
            eventId={eventId}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
            buyerEventItemId={buyerEventItemId}
          />
        );
      case "AuctionBid":
        return (
          <BidlogFirst
            AuctionView={() => {
              updateView({ view: "AuctionView" });
            }}
            eventId={eventId}
            AuctionViewFirst={() => {
              updateView({ view: "AuctionViewFirst" });
            }}
            AuctionSummary={(buyerId) => {
              updateView({ view: "AuctionSummary", buyerId });
            }}
          />
        );
      case "AuctionViewFirst":
        return (
          <AuctionViewFirst
            BidlogFirst={() => {
              updateView({ view: "AuctionBid" });
            }}
          />
        );
      case "AuctionSummary":
        return (
          <AuctionSummary
            BidlogFirst={() => {
              updateView({ view: "AuctionBid" });
            }}
            eventId={eventId}
            buyerId={buyerId}
          />
        );
      case "BidlogSecond":
        return userData.role === "BUYER" ? (
          <BidlogSecondBuyer
            AuctionView={() => {
              updateView({ view: "AuctionView" });
            }}
            eventItemId={eventItemId}
            eventId={eventId}
          />
        ) : (
          <BidlogSecond
            AuctionView={() => {
              updateView({ view: "AuctionView" });
            }}
            eventItemId={eventItemId}
            eventId={eventId}
          />
        );
      case "DashBuyerDetail":
        return (
          <DashBuyerDetail
            DashEventDetail={(buyerId, buyerEventId) => {
              updateView({
                view: "DashEventDetail",
                buyerEventId,
              });
            }}
            BidlogFirst={() => {
              updateView({ view: "AuctionBid" });
            }}
            buyerId={buyerId}
          />
        );

      case "DashEventDetail":
        return (
          <DashEventDetail
            BuyerBidLog={(eventItemId) => {
              updateView({
                view: "BuyerBidLog",
                buyerEventItemId: eventItemId,
              });
            }}
            DashBuyerDetail={(buyerId) => {
              updateView({ view: "DashBuyerDetail", buyerId });
            }}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
          />
        );
      case "BuyerBidLog":
        return (
          <BuyerBidLog
            DashEventDetail={() => {
              updateView({ view: "DashEventDetail" });
            }}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
            buyerEventItemId={buyerEventItemId}
          />
        );
      case "EditTabEvent":
        return (
          <EditTabEvent
            eventEditId={eventId}
            onBack={() => updateView({ view: "EditEvent" })}
          />
        );

      case "EditEvent":
        return (
          <EditEvent
            AuctionTable={() => {
              updateView({ view: "AuctionTable", eventId: "" });
            }}
            EditTabEvent={(eventId) => {
              updateView({ view: "EditTabEvent", eventId });
            }}
            eventId={eventId}
          />
        );
      case "AuctionTable":
        return userData.role === "BUYER" ? (
          <AuctionTableBuyer
            onView={(eventId) => {
              updateView({ view: "AuctionView", eventId });
            }}
            onEdit={(eventId) => {
              updateView({ view: "EditEvent", eventId });
            }}
          />
        ) : (
          <AuctionTable
            onView={(eventId) => {
              updateView({ view: "AuctionView", eventId });
            }}
            onEdit={(eventId) => {
              updateView({ view: "EditEvent", eventId });
            }}
          />
        );

      default:
        return userData.role === "BUYER" ? (
          <AuctionTableBuyer
            onView={(eventId) => {
              updateView({ view: "AuctionView", eventId });
            }}
            onEdit={(eventId) => {
              updateView({ view: "EditEvent", eventId });
            }}
          />
        ) : (
          <AuctionTable
            onView={(eventId) => {
              updateView({ view: "AuctionView", eventId });
            }}
            onEdit={(eventId) => {
              updateView({ view: "EditEvent", eventId });
            }}
          />
        );
    }
  };

  return (
    <div className={classes.section}>
      <div className="container">
        <div className={classes.Dashboard}>
          <div className={classes.dashboardCard}>
            <DashboardMenu />
            <div className={classes.dashboardCards}>
              <div className={classes.auctionDetail}>{renderComponent()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardAuction;
